export const SHOPPING_CART_DATA_QUERY_KEY = 'shopping-card-data';
export const SYNC_CART_COOOKIE_QUERY_KEY = 'sync-shopping-cart-cookie';

export type UseShoppingCartProps = {
  resetPaymentsOnMount?: boolean;
  disableGetShoppingCart?: boolean;
  mainCart?: boolean;
};
